<section id="microsoft">
    <article class="banner">
        <div class="wrapper">
            <img class="badge" src="../../../../../assets/img/microsoft365/MicrosoftPartner.webp" alt="badge">
            <div class="info">
                <img class="m365" src="../../../../../assets/img/microsoft365/Microsoft_365_logo.webp" alt="">
                <h2>{{ 'cloud.title543' | translate }}</h2>
                <p>{{ 'cloud.title544' | translate }}</p>
                <ul>
                    <li>{{ 'cloud.title545' | translate }}</li>
                    <li>{{ 'cloud.title546' | translate }}</li>
                    <li>{{ 'cloud.title547' | translate }}</li>
                    <li>{{ 'cloud.title548' | translate }}</li>
                </ul>
            </div>
            <div class="img">
                <img src="../../../../../assets/img/microsoft365/banner.webp" alt="banner">
            </div>
        </div>
    </article>
    <article class="beneficios">
        <div class="wrapper">
            <h2>{{ 'cloud.title549' | translate }}</h2>
            <div class="card-wrapper">
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/contrato.svg" alt="contrato">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title550' | translate }}</h3>
                        <p>{{ 'cloud.title551' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/add.svg" alt="add">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title552' | translate }}</h3>
                        <p>{{ 'cloud.title553' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/cambie.svg" alt="cambie">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title554' | translate }}</h3>
                        <p>{{ 'cloud.title555' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/cambio.svg" alt="cambio">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title556' | translate }}</h3>
                        <p>{{ 'cloud.title557' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/pago.svg" alt="pago">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title558' | translate }}</h3>
                        <p>{{ 'cloud.title559' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/movil.svg" alt="movil">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title560' | translate }}</h3>
                        <p>{{ 'cloud.title561' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/cloud.svg" alt="cloud">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title562' | translate }}</h3>
                        <p>{{ 'cloud.title563' | translate }}</p>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="../../../../../assets/img/microsoft365/icons/colaboracion.svg" alt="colaboracion.svg">
                    </div>
                    <div class="info">
                        <h3>{{ 'cloud.title564' | translate }}</h3>
                        <p>{{ 'cloud.title565' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </article>

    <article class="servicios">
        <div class="wrapper">
            <h2>{{ 'cloud.title566' | translate }}</h2>
            <div class="card-wrapper">
                <div [ngClass]="{'active': servicio === 'office'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.89 111.06">
                            <path class="cls-1" d="M112.14,18.08h-6.33V14.13a1.75,1.75,0,0,0-1.75-1.75H88.94a1.75,1.75,0,0,0-1.75,1.75v3.95H83.73L80.94,1.46A1.75,1.75,0,0,0,79.22,0H39.67a1.75,1.75,0,0,0-1.73,1.46L35.15,18.08H31.69V14.13a1.75,1.75,0,0,0-1.75-1.75H14.83a1.75,1.75,0,0,0-1.75,1.75v3.95H6.75A6.76,6.76,0,0,0,0,24.83V97.52a6.75,6.75,0,0,0,6.75,6.75h6.77l1.61,5.53a1.75,1.75,0,0,0,1.68,1.26H28a1.74,1.74,0,0,0,1.68-1.26l1.62-5.53H87.63l1.61,5.53a1.76,1.76,0,0,0,1.68,1.26h11.16a1.75,1.75,0,0,0,1.68-1.26l1.61-5.53h6.77a6.75,6.75,0,0,0,6.75-6.75V24.83A6.76,6.76,0,0,0,112.14,18.08Zm-21.45-2.2h11.62v2.2H90.69ZM41.15,3.5H77.74l2.44,14.58H74.29V8.42a1.75,1.75,0,0,0-1.75-1.75H46.34a1.76,1.76,0,0,0-1.75,1.75v9.66H38.7Zm6.94,14.58V10.17h22.7v7.91Zm-31.51-2.2H28.19v2.2H16.58Zm-9.83,5.7H112.14a3.26,3.26,0,0,1,3.25,3.25V43.18L65.73,57.54v-2.6A1.75,1.75,0,0,0,64,53.19H54.91a1.75,1.75,0,0,0-1.75,1.75v2.6L3.5,43.18V24.83A3.26,3.26,0,0,1,6.75,21.58ZM62.23,56.69v9H56.66v-9ZM26.65,107.56H18.12l-1-3.29H27.61Zm74.12,0H92.24l-1-3.29h10.44Zm11.37-6.79H6.75A3.25,3.25,0,0,1,3.5,97.52V46.82L53.16,61.18v6.23a1.75,1.75,0,0,0,1.75,1.75H64a1.75,1.75,0,0,0,1.75-1.75V61.18l49.66-14.36v50.7A3.25,3.25,0,0,1,112.14,100.77Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title567' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'acceso'}" class="card">
                    <div class="img">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	                        viewBox="0 0 140.9 93.1" style="enable-background:new 0 0 140.9 93.1;" xml:space="preserve">
                        		<path d="M93.9,0H9.1C4.1,0,0,4.1,0,9.1v48.5c0,5,4.1,9.1,9.1,9.1h28.4v10.3c0,2.8-2.3,5.1-5.1,5.1
                        			c-5.1,0-9.2,4.1-9.2,9.2c0,1,0.8,1.8,1.7,1.8c0,0,0,0,0,0h53.1c1,0,1.8-0.8,1.8-1.8c0-5.1-4.1-9.2-9.2-9.2c-2.8,0-5.1-2.3-5.1-5.1
                        			V66.8h28.4c5,0,9.1-4.1,9.1-9.1V9.1C103,4.1,98.9,0,93.9,0z M9.1,3.5h84.8c3.1,0,5.6,2.5,5.6,5.6V44h-96V9.1C3.5,6,6,3.5,9.1,3.5z
                        			 M76,89.6H27c0.8-2.4,3-4,5.4-4h38.2C73.1,85.6,75.3,87.2,76,89.6z M63.7,82.1H39.3c1.1-1.5,1.7-3.2,1.7-5.1V66.8h21v10.3
                        			C62,78.9,62.6,80.7,63.7,82.1z M93.9,63.3H9.1c-3.1,0-5.6-2.5-5.6-5.6V47.5h96v10.2C99.5,60.7,97,63.2,93.9,63.3z"/>
                        		<path d="M51.5,50c-3,0-5.3,2.4-5.3,5.4c0,3,2.4,5.3,5.4,5.3c3,0,5.3-2.4,5.3-5.3C56.9,52.4,54.5,50,51.5,50z
                        			 M51.5,57.2c-1,0-1.8-0.8-1.8-1.9s0.8-1.8,1.9-1.8c1,0,1.8,0.8,1.8,1.8C53.4,56.4,52.6,57.2,51.5,57.2
                        			C51.5,57.2,51.5,57.2,51.5,57.2z"/>
                        		<path d="M110.1,92.5h26.2c2.5,0,4.5-2,4.6-4.5V45.6c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0h-26.2c-2.5,0-4.6,2-4.6,4.6V88
                        			C105.6,90.5,107.6,92.5,110.1,92.5z M139.1,81.3h-31.8V51h31.8L139.1,81.3z M136.3,90.8h-26.2c-1.5,0-2.8-1.2-2.8-2.8v-4.9h31.8
                        			V88C139.1,89.5,137.9,90.8,136.3,90.8L136.3,90.8z M110.1,42.8h26.2c1.6,0,2.8,1.3,2.8,2.8v3.6h-31.8v-3.7
                        			C107.3,44,108.6,42.8,110.1,42.8L110.1,42.8z"/>
                        		<path d="M119.1,47.1h8.3c0.5-0.1,0.8-0.5,0.8-1c0-0.4-0.4-0.7-0.8-0.8h-8.3c-0.5-0.1-0.9,0.3-1,0.8s0.3,0.9,0.8,1
                        			C118.9,47.1,119,47.1,119.1,47.1z"/>
                        		<path d="M123.2,84.1c-1.5,0-2.7,1.3-2.7,2.8c0,1.5,1.3,2.7,2.8,2.7c1.5,0,2.7-1.2,2.7-2.7
                        			C126,85.4,124.8,84.1,123.2,84.1C123.2,84.1,123.2,84.1,123.2,84.1z M123.2,87.9c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1
                        			S123.8,87.9,123.2,87.9z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title568' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'admin'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.89 118.89">
                            <path d="M59.44,30.84A28.58,28.58,0,0,0,35.09,74.42a1.75,1.75,0,0,0,.18.29,28.78,28.78,0,0,0,8.91,8.9,1.26,1.26,0,0,0,.28.19,28.6,28.6,0,1,0,15-53Zm-20.54,43,5.4-5.4a1.75,1.75,0,0,0,.34-2A16.37,16.37,0,0,1,64.07,43.73L53.9,53.9a1.74,1.74,0,0,0-.51,1.24v8.61a1.75,1.75,0,0,0,1.75,1.75h8.61A1.8,1.8,0,0,0,65,65L75.16,54.82A16.37,16.37,0,0,1,52.42,74.24a1.74,1.74,0,0,0-2,.35L45,80A25.35,25.35,0,0,1,38.9,73.85Zm20.54,10.7a24.86,24.86,0,0,1-11.31-2.71l3.94-3.94a19.87,19.87,0,0,0,25.34-27,1.79,1.79,0,0,0-1.29-1,1.71,1.71,0,0,0-1.53.49L63,62H56.89V55.86L68.45,44.3A1.75,1.75,0,0,0,68,41.48,19.87,19.87,0,0,0,41,66.82l-3.93,3.94A25.1,25.1,0,1,1,59.44,84.55Z"/>
                            <path d="M117.14,48.11H105.85a47.22,47.22,0,0,0-5.58-13.46l8-8a1.73,1.73,0,0,0,0-2.47L94.7,10.63a1.81,1.81,0,0,0-2.47,0l-8,8A47.36,47.36,0,0,0,70.78,13V1.75A1.75,1.75,0,0,0,69,0H49.86a1.75,1.75,0,0,0-1.75,1.75V13a47.25,47.25,0,0,0-13.46,5.59l-8-8a1.75,1.75,0,0,0-2.47,0L10.63,24.19a1.75,1.75,0,0,0,0,2.47l8,8A47.25,47.25,0,0,0,13,48.11H1.75A1.75,1.75,0,0,0,0,49.86V69a1.75,1.75,0,0,0,1.75,1.75H13a47.36,47.36,0,0,0,5.59,13.46l-8,8a1.75,1.75,0,0,0,0,2.47l13.56,13.55a1.73,1.73,0,0,0,2.47,0l8-8a47.22,47.22,0,0,0,13.46,5.58v11.29a1.75,1.75,0,0,0,1.75,1.75H69a1.76,1.76,0,0,0,1.75-1.75V105.85a47.34,47.34,0,0,0,13.46-5.58l8,8a1.79,1.79,0,0,0,2.47,0L108.25,94.7a1.73,1.73,0,0,0,0-2.47l-8-8a47.34,47.34,0,0,0,5.58-13.46h11.29A1.76,1.76,0,0,0,118.89,69V49.86A1.75,1.75,0,0,0,117.14,48.11Zm-1.75,19.17H104.46a1.77,1.77,0,0,0-1.72,1.38,43.67,43.67,0,0,1-6.17,14.88,1.76,1.76,0,0,0,.23,2.19l7.74,7.73L93.46,104.54,85.73,96.8a1.76,1.76,0,0,0-2.19-.23,43.67,43.67,0,0,1-14.88,6.17,1.76,1.76,0,0,0-1.38,1.72v10.93H51.61V104.46a1.76,1.76,0,0,0-1.39-1.72,43.7,43.7,0,0,1-14.87-6.17,1.75,1.75,0,0,0-2.19.23l-7.74,7.74L14.35,93.46l7.73-7.73a1.74,1.74,0,0,0,.23-2.19,44.07,44.07,0,0,1-6.17-14.88,1.75,1.75,0,0,0-1.71-1.38H3.5V51.61H14.43a1.75,1.75,0,0,0,1.71-1.39,44.1,44.1,0,0,1,6.17-14.87,1.74,1.74,0,0,0-.23-2.19l-7.73-7.74L25.42,14.35l7.74,7.73a1.74,1.74,0,0,0,2.19.23,43.9,43.9,0,0,1,14.87-6.17,1.75,1.75,0,0,0,1.39-1.71V3.5H67.28V14.43a1.74,1.74,0,0,0,1.38,1.71,43.87,43.87,0,0,1,14.88,6.17,1.74,1.74,0,0,0,2.19-.23l7.73-7.73,11.08,11.07L96.8,33.16a1.75,1.75,0,0,0-.23,2.19,43.62,43.62,0,0,1,6.17,14.87,1.76,1.76,0,0,0,1.72,1.39h10.93Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title569' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'correo'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.89 81.2">
                            <path class="cls-1" d="M117.14,0H1.75A1.75,1.75,0,0,0,0,1.75v77.7A1.75,1.75,0,0,0,1.75,81.2H117.14a1.75,1.75,0,0,0,1.75-1.75V1.75A1.75,1.75,0,0,0,117.14,0ZM63.57,46.44a6.28,6.28,0,0,1-8.25,0L6.4,3.5H112.49ZM43.36,40.6,3.5,75.58v-70ZM46,42.93l7,6.14a9.78,9.78,0,0,0,12.86,0l7-6.14L112.49,77.7H6.4Zm29.5-2.33,39.87-35v70Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title570' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'compartir'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.39 114.99">
                            <path d="M92.55,19.81a1.9,1.9,0,0,1-.68.42L75.05,25.9a1.75,1.75,0,0,1-2.12-2.43l2.62-5.3C52.45,7,38.17,20.28,38,20.42a1.75,1.75,0,0,1-2.73-2.13c.15-.27,15.44-26.09,46.14-12L84.07,1a1.75,1.75,0,0,1,3.23.22L93,18A1.77,1.77,0,0,1,92.55,19.81ZM77.94,21.23l11.15-3.76L85.33,6.31,83.81,9.39a1.76,1.76,0,0,1-2.35.79C63.59,1.32,51.53,6.84,44.8,12.56,52.28,9.71,64,8.18,78.7,15.83a1.75,1.75,0,0,1,.76,2.33Z"/>
                            <path d="M85.28,102.74c-6.73,6.73-20.46,15.51-41.26,6L41.39,114a1.76,1.76,0,0,1-3.23-.22L32.49,97a1.75,1.75,0,0,1,1.1-2.22l16.82-5.67a1.74,1.74,0,0,1,2.12,2.43l-2.62,5.3C73,108,87.29,94.7,87.43,94.57a1.75,1.75,0,0,1,2.73,2.13A33.21,33.21,0,0,1,85.28,102.74ZM42,105.14a1.76,1.76,0,0,1,2-.33c17.87,8.85,29.93,3.34,36.66-2.38-7.48,2.85-19.2,4.38-33.9-3.27A1.75,1.75,0,0,1,46,96.83l1.52-3.07L36.37,97.52l3.76,11.16,1.52-3.08A1.92,1.92,0,0,1,42,105.14Z"/>
                            <path d="M14.33,74.69H7.72a.83.83,0,0,0,0,1.65h6.61a.83.83,0,1,0,0-1.65Z"/>
                            <path d="M14.33,35.52H28.6a.83.83,0,0,0,0-1.66H14.33a.83.83,0,1,0,0,1.66Z"/>
                            <path d="M35.21,40.67H7.72a.83.83,0,0,0,0,1.65H35.21a.83.83,0,1,0,0-1.65Z"/>
                            <path d="M35.21,54.27H7.72a.83.83,0,0,0,0,1.66H35.21a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M35.21,47.47H7.72a.83.83,0,0,0,0,1.66H35.21a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M35.21,61.08H7.72a.83.83,0,0,0,0,1.66H35.21a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M35.21,67.88H7.72a.83.83,0,0,0,0,1.66H35.21a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M43.65,33.86h-.72V27.8A.83.83,0,0,0,42.1,27H7.72a.78.78,0,0,0-.58.24l-6.9,6.9a.83.83,0,0,0-.24.58V82.41a.83.83,0,0,0,.83.83H42.1a.83.83,0,0,0,.83-.83V40h.72a3.08,3.08,0,1,0,0-6.16ZM6.9,29.79v4.07H2.83ZM41.27,81.58H1.66V35.52H7.72a.83.83,0,0,0,.83-.83V28.62H41.27v5.24h-.72a3.09,3.09,0,0,0-3.08,3.08.83.83,0,1,0,1.66,0,1.43,1.43,0,0,1,1.42-1.42h.72Zm2.38-43.22h-.72V35.52h.72a1.42,1.42,0,1,1,0,2.84Z"/>
                            <path d="M95,74.69H88.38a.83.83,0,0,0,0,1.65H95a.83.83,0,1,0,0-1.65Z"/>
                            <path d="M95,35.52h14.27a.83.83,0,1,0,0-1.66H95a.83.83,0,1,0,0,1.66Z"/>
                            <path d="M115.87,40.67H88.38a.83.83,0,0,0,0,1.65h27.49a.83.83,0,1,0,0-1.65Z"/>
                            <path d="M115.87,54.27H88.38a.83.83,0,0,0,0,1.66h27.49a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M115.87,47.47H88.38a.83.83,0,0,0,0,1.66h27.49a.83.83,0,1,0,0-1.66Z"/>
                            <path d="M115.87,61.08H88.38a.83.83,0,0,0,0,1.66h27.49a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M115.87,67.88H88.38a.83.83,0,0,0,0,1.66h27.49a.83.83,0,0,0,0-1.66Z"/>
                            <path d="M124.31,33.86h-.72V27.8a.83.83,0,0,0-.83-.83H88.38a.78.78,0,0,0-.58.24l-6.9,6.9a.83.83,0,0,0-.24.58V82.41a.83.83,0,0,0,.83.83h41.27a.83.83,0,0,0,.83-.83V40h.72a3.08,3.08,0,0,0,0-6.16ZM87.56,29.79v4.07H83.49Zm34.37,51.79H82.32V35.52h6.06a.83.83,0,0,0,.83-.83V28.62h32.72v5.24h-.72a3.08,3.08,0,0,0-3.08,3.08.83.83,0,0,0,1.66,0,1.43,1.43,0,0,1,1.42-1.42h.72Zm2.38-43.22h-.72V35.52h.72a1.42,1.42,0,1,1,0,2.84Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title571' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'video'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.16 89.3">
                            <path class="cls-1" d="M102.3,40.52a1.75,1.75,0,0,0-1.73,0L79.26,52.19V40.49a6.36,6.36,0,0,0-6.35-6.35H62.54A18.81,18.81,0,1,0,33.22,15a13.89,13.89,0,1,0-20,19.15H6.35A6.36,6.36,0,0,0,0,40.49V83A6.36,6.36,0,0,0,6.35,89.3H72.91A6.36,6.36,0,0,0,79.26,83V71.25L100.57,83a1.77,1.77,0,0,0,.84.21,1.74,1.74,0,0,0,1.75-1.75V42A1.75,1.75,0,0,0,102.3,40.52ZM51.65,3.5A15.32,15.32,0,1,1,36.33,18.82,15.33,15.33,0,0,1,51.65,3.5ZM40.76,34.14H31.62a14,14,0,0,0,3.88-5.71A18.88,18.88,0,0,0,40.76,34.14ZM12,23.74a10.4,10.4,0,1,1,10.4,10.4A10.41,10.41,0,0,1,12,23.74ZM75.76,83a2.86,2.86,0,0,1-2.85,2.85H6.35A2.86,2.86,0,0,1,3.5,83V40.49a2.86,2.86,0,0,1,2.85-2.85H72.91a2.86,2.86,0,0,1,2.85,2.85Zm23.9-4.49-20.4-11.2V56.18L99.66,45Z"/>
                            <path class="cls-1" d="M29.72,63.58H11.14a1.75,1.75,0,0,0-1.75,1.75V78.59a1.75,1.75,0,0,0,1.75,1.75H29.72a1.75,1.75,0,0,0,1.75-1.75V65.33A1.75,1.75,0,0,0,29.72,63.58ZM28,76.84H12.89V67.08H28Z"/>
                            <path class="cls-1" d="M65.87,76.84H42.16a1.75,1.75,0,0,0,0,3.5H65.87a1.75,1.75,0,0,0,0-3.5Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title572' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'sla'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.5 118.5">
                            <path class="cls-1" d="M75.47,84.42a1.75,1.75,0,0,0-1.75,1.75v6a1.75,1.75,0,0,0,3.5,0v-6A1.75,1.75,0,0,0,75.47,84.42Z"/>
                            <path class="cls-1" d="M116.75,109h-7.1V31.13a1.75,1.75,0,0,0-1.75-1.75h-18a1.75,1.75,0,0,0-1.75,1.75V109H83.22V40.51a1.75,1.75,0,0,0-1.75-1.75h-18a1.75,1.75,0,0,0-1.75,1.75V109H56.78V49.88A1.75,1.75,0,0,0,55,48.13H37a1.75,1.75,0,0,0-1.75,1.75V109H30.35V59.25A1.75,1.75,0,0,0,28.6,57.5h-18a1.75,1.75,0,0,0-1.75,1.75V109H1.75A1.75,1.75,0,0,0,0,110.75v6a1.75,1.75,0,0,0,1.75,1.75h115a1.75,1.75,0,0,0,1.75-1.75v-6A1.75,1.75,0,0,0,116.75,109ZM91.65,32.88h14.5V109H91.65ZM65.22,42.26h14.5V109H65.22ZM38.78,51.63h14.5V109H38.78ZM12.35,61h14.5v48H12.35ZM115,115H3.5v-2.5H115Z"/>
                            <path class="cls-1" d="M10.6,41.65a2,2,0,0,0,.58-.1L104.51,8.46l-1.84,3.85a1.76,1.76,0,0,0,.83,2.33,1.68,1.68,0,0,0,.75.17,1.74,1.74,0,0,0,1.58-1l3.65-7.66a1.74,1.74,0,0,0-.82-2.33L101,.17a1.75,1.75,0,1,0-1.51,3.16l3.85,1.83L10,38.25a1.75,1.75,0,0,0,.59,3.4Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title573' | translate }}</p>
                </div>
                <div [ngClass]="{'active': servicio === 'soporte'}" class="card">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.7 103.04">
                            <path class="cls-1" d="M4.79,80h0l9.29,2.15a6,6,0,0,0,5.36,3.38H27a6,6,0,0,0,5.94-5.94V51.84A6,6,0,0,0,27,45.9H22.65V32.2A28.7,28.7,0,1,1,80,32.2V45.9H75.73a5.94,5.94,0,0,0-5.94,5.94V79.56a5.94,5.94,0,0,0,5.94,5.94H80v9H64.31V91.14a1.75,1.75,0,0,0-1.75-1.75H49.14a6.83,6.83,0,1,0,0,13.65H62.56a1.75,1.75,0,0,0,1.75-1.75V98H81.79a1.75,1.75,0,0,0,1.75-1.75V85.49a6,6,0,0,0,5.07-3.37L97.9,80h0a6.16,6.16,0,0,0,4.8-6V57.88a6.16,6.16,0,0,0-4.8-6l-9.08-2.1a6,6,0,0,0-5.28-3.84V32.2a32.2,32.2,0,1,0-64.39,0V45.91a6,6,0,0,0-5.27,3.84l-9.09,2.1a6.16,6.16,0,0,0-4.79,6V73.94A6.16,6.16,0,0,0,4.79,80Zm56,19.57H49.14a3.33,3.33,0,1,1,0-6.65H60.81ZM99.2,57.88V73.94a2.68,2.68,0,0,1-2.08,2.62L89.2,78.39v-25l7.91,1.83A2.68,2.68,0,0,1,99.2,57.88Zm-13.5-6V79.56A2.44,2.44,0,0,1,83.26,82H75.73a2.44,2.44,0,0,1-2.44-2.44V51.84a2.44,2.44,0,0,1,2.44-2.44h7.53A2.44,2.44,0,0,1,85.7,51.84ZM19.44,49.4H27a2.44,2.44,0,0,1,2.44,2.44V79.56A2.44,2.44,0,0,1,27,82H19.44A2.45,2.45,0,0,1,17,79.56V51.84A2.45,2.45,0,0,1,19.44,49.4ZM3.5,57.88a2.68,2.68,0,0,1,2.08-2.62l7.91-1.83v25L5.58,76.56A2.68,2.68,0,0,1,3.5,73.94Z"/>
                        </svg>
                    </div>
                    <p>{{ 'cloud.title574' | translate }}</p>
                </div>
            </div>
        </div>
    </article>

    <article class="apps">
        <div class="wrapper">
            <h2>Apps</h2>
            <div class="apps-wrapper">
                <div class="app" attr.data-tool="{{ 'cloud.title647' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Word.webp" alt="Word">
                    <p>Word</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title648' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/ExcelA.png" alt="Excel">
                    <p>Excel</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title649' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Powerpoint.webp" alt="Powerpoint">
                    <p>Powerpoint</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title650' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Onenote.webp" alt="Onenote">
                    <p>Onenote</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title651' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Onedrive.webp" alt="Onedrive">
                    <p>Onedrive</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title652' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Outlook.png" alt="Outlook">
                    <p>Outlook</p>
                </div>
                <div class="app" attr.data-tool="{{ 'cloud.title653' | translate }}">
                    <img src="../../../../../assets/img/microsoft365/apps/Teams.webp" alt="Teams">
                    <p>Teams</p>
                </div>
            </div>
        </div>
        <div class="bg">
            <img src="https://blobs.officehome.msocdn.com/images/content/images/office-apps-347d86a528.gif" alt="office-bg">
        </div>
    </article>


</section>

<div (click)="scroll(formbox)" class="padded">
    <app-banner></app-banner>
</div>


<section id="microsoft">

    <article class="features">
        <div class="wrapper">
            <div class="feature">
                <div class="img">
                    <img src="../../../../../assets/img/microsoft365/devices.webp" alt="devices">
                </div>
                <div class="card">
                    <h3>{{ 'cloud.title575' | translate }}</h3>
                    <p>{{ 'cloud.title576' | translate }}</p>
                </div>
            </div>

            <div class="feature">
                <div class="card inv">
                    <h3>{{ 'cloud.title577' | translate }}</h3>
                    <ul>
                        <li>{{ 'cloud.title578' | translate }}</li>
                        <li>{{ 'cloud.title579' | translate }}</li>
                        <li>{{ 'cloud.title580' | translate }}</li>
                        <li>{{ 'cloud.title581' | translate }}</li>
                    </ul>
                </div>
                <div class="img">
                    <img src="../../../../../assets/img/microsoft365/app.webp" alt="apps">
                </div>
            </div>

            <div class="feature">
                <div class="img">
                    <img src="../../../../../assets/img/microsoft365/config.webp" alt="config">
                </div>
                <div class="card">
                    <h3>{{ 'cloud.title582' | translate }}</h3>
                    <ul>
                        <li>{{ 'cloud.title583' | translate }}</li>
                        <li>{{ 'cloud.title584' | translate }}</li>
                    </ul>
                </div>
            </div>

            <div class="feature">
                <div class="card inv">
                    <h3>{{ 'cloud.title585' | translate }}</h3>
                    <ul>
                        <li>{{ 'cloud.title586' | translate }}</li>
                        <li>{{ 'cloud.title587' | translate }}</li>
                    </ul>
                </div>
                <div class="img">
                    <img src="../../../../../assets/img/microsoft365/update.webp" alt="update">
                </div>
            </div>
        </div>
    </article>

    <article class="planes">
        <div class="wrapper">
            <h2>{{ 'cloud.title588' | translate }}</h2>
            <p>{{ 'cloud.title589' | translate }}</p>
            <nav>
                <ul>
                    <li [ngClass]="{'active' : plan === 'business'}" (click)="changePlan('business')">{{ 'cloud.title590' | translate }}</li>
                    <li [ngClass]="{'active' : plan === 'enterprise'}" (click)="changePlan('enterprise')">{{ 'cloud.title591' | translate }}</li>
                    <li [ngClass]="{'active' : plan === 'exchange'}" (click)="changePlan('exchange')">{{ 'cloud.title592' | translate }}</li>
                    <li [ngClass]="{'active' : plan === 'kiosk'}" (click)="changePlan('kiosk')">{{ 'cloud.title593' | translate }}</li>
                </ul>
            </nav>
            <div class="planes-wrapper {{plan}}" [style.maxHeight]="planH">
                <div class="plan" id="business">
                    <table>
                        <tbody>
                            <tr>
                                <th></th>
                                <th>
                                    <p>Microsoft 365 Business Basic</p>
                                </th>
                                <th>
                                    <p>Microsoft 365 Business Standard</p>
                                </th>
                                <th>
                                    <p>Microsoft 365 Business Premium</p>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title597' | translate }}</th>
                                <td><p>300</p></td>
                                <td><p>300</p></td>
                                <td><p>300</p></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title598' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title599' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title600' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title601' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title602' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title603' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title604' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title605' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title606' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="plan" id="enterprise">
                    <table>
                        <tbody>
                            <tr>
                                <th></th>
                                <th>
                                    <p>Microsoft 365 Enterprise E1</p>
                                </th>
                                <th>
                                    <p>Microsoft 365 Apps for business</p>
                                </th>
                                <th>
                                    <p>Microsoft 365 Enterprise E3</p>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title608' | translate }}</th>
                                <td><p>{{ 'cloud.title609' | translate }}</p></td>
                                <td><p>{{ 'cloud.title609' | translate }}</p></td>
                                <td><p>{{ 'cloud.title609' | translate }}</p></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title610' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title599' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title600' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title601' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title602' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><p>Próximamente</p></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title603' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title604' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title605' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title606' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title612' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title613' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title614' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title615' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title616' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- plan enterprise -->
                <div class="plan" id="exchange">
                    <table>
                        <tbody>
                            <tr>
                                <th></th>
                                <th>
                                    <p>Exchange Online Plan 1</p>
                                </th>
                                <th>
                                    <p>Exchange Online Plan 2</p>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title618' | translate }}</th>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title619' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title620' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title621' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title622' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title623' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title624' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title625' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title626' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title627' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title628' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title629' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- plan kiosk -->
                <div class="plan" id="kiosk">
                    <table>
                        <tbody>
                            <tr>
                                <th></th>
                                <th>
                                    <p>Exchange Online Kiosk</p>
                                </th>
                                <th>
                                    <p>Microsoft 365 Enterprise K1</p>
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>
                                    <p>{{ 'cloud.title630' | translate }}</p>
                                </th>
                                <th>
                                    <p>{{ 'cloud.title631' | translate }}</p>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title632' | translate }}</th>
                                <td><p>{{ 'cloud.title633' | translate }}</p></td>
                                <td><p>{{ 'cloud.title633' | translate }}</p></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title634' | translate }}</th>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                                <td>
                                    <img src="../../../../../assets/img/tick.svg" alt="yes">
                                    <p>{{ 'cloud.title611' | translate }}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title634' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title635' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title636' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title637' | translate }}</th>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title638' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                            <tr>
                                <th>{{ 'cloud.title639' | translate }}</th>
                                <td><img src="../../../../../assets/img/equis.svg" alt="no"></td>
                                <td><img src="../../../../../assets/img/tick.svg" alt="yes"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <button (click)="goToSection('form-g')" type="button" class="cta">      <h3>{{ 'cloud.title640' | translate }}</h3>
            </button>
        </div>
    </article>

    <article class="video">
        <div class="wrapper">
            <div class="video-wrap">
                <div class="frame">
                    <iframe src="https://www.youtube.com/embed/vt9kUQdkutM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </article>

    <article class="credenciales">
        <img class="bg" src="../../../../../assets/img/microsoft365/clouds.png" alt="clouds">
        <div class="wrapper">
            <h2>{{ 'cloud.title641' | translate }}<br>{{ 'cloud.title642' | translate }}</h2>
            <div class="card-wrapper">
                <div class="card">
                    <div class="high">
                        <img class="icloud-b" src="../../../../assets/img/user-b.svg" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/user.svg" alt="">
                        <div class="table">
                            <div class="cell figure">
                                <span>15</span>
                            </div>
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title643' | translate }}</h3>
                    </div>
                </div>
                <div class="card">
                    <div class="high">
                        <img class="icloud" src="../../../../assets/img/cloud.svg" alt="">
                        <div class="table">
                            <div><p>+</p></div>
                            <div class="cell figure">
                                <span>350</span>
                            </div>
                            <div class="min"><span>K</span></div>
                        </div>

                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title644' | translate }}</h3>
                    </div>
                </div>
                <div class="card">
                    <div class="high">
                        <img class="lm" src="../../../../../assets/img/microsoft365/Microsoft.svg" alt="">
                        <div class="table" style="padding-top: 0px;">
                            <div class="cell figure">
                                <div>Microsoft Official Cloud Solution Provider</div>
                            </div>
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title645' | translate }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </article>
<!--
    <app-interes [intereses]="interesesCards"></app-interes> -->

<div class="content-area">
    <div class="wrap">
        <section class="intereses">
            <div class="wrapper">
                <h3>{{ 'cloud.title646' | translate }}</h3>
                <div class="card-wrapper">
                    <div class="icard" routerLink="/azure">
                        <img class="ncloud" src="../../../../../assets/img/azure.png" alt="microsoft azure">
                        <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                    </div>
                    <div class="icard" routerLink="/acceleracion-digital">
                        <img class="img-iconb" src="../../../../../assets/img/acceleracion-digital/logo.webp" alt="aceleracion digital">
                        <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>


    <div #formbox>
        <app-form id="form-g"></app-form>
    </div>

</section>

